import { MarketersPageStates } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETERS_PAGE_STATUS = 'UPDATE_INTERNAL_MARKETERS_PAGE_STATUS';
export type UPDATE_INTERNAL_MARKETERS_PAGE_STATUS = typeof UPDATE_INTERNAL_MARKETERS_PAGE_STATUS;

export interface UpdateInternalMarketersPageStatus {
    type: UPDATE_INTERNAL_MARKETERS_PAGE_STATUS;
    status: MarketersPageStates;
}

export function updateInternalMarketersPageStatusAction(
    status: MarketersPageStates
): UpdateInternalMarketersPageStatus {
    return {
        type: UPDATE_INTERNAL_MARKETERS_PAGE_STATUS,
        status
    };
}
